/* For the Subscribe Button animation */
document.addEventListener("DOMContentLoaded", function() {
    const emailInput = document.querySelector('.input-group-field.newsletter__input');
    const submitButton = document.querySelector('.btn.button-for-subscribe');

    emailInput.addEventListener('input', function() {
      if (emailInput.value.trim() !== '') {
        submitButton.disabled = false;
      } else {
        submitButton.disabled = true;
      }
    });

    submitButton.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent the default form submission to show the animation

      // Trigger confetti animation
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 }
      });

      // After the animation, submit the form programmatically
      setTimeout(function() {
        submitButton.closest('form').submit();
      }, 1000); // Adjust the timing as necessary
    });
});